import { AfterViewInit, Component, Input, ChangeDetectionStrategy } from "@angular/core";
import * as Highcharts from 'highcharts/highstock';
import {MatTabsModule} from '@angular/material/tabs';
import { TranslateModule } from "@ngx-translate/core";
import { ITeam } from "@teammood/team";


@Component({
    selector: "recurring-closed-poll-result-trends-chart",
    templateUrl: "./recurring-closed-poll-result-trends-chart.component.html",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatTabsModule,
        TranslateModule
    ]
})
export class RecurringClosedPollResultTrendsChartComponent implements AfterViewInit {

    teams: ITeam[]

    @Input() series: any;
    @Input() dates: any;
    @Input() chartId: string;
    
    constructor() {}

    ngAfterViewInit(){
        Highcharts.chart('questionTrendsClosedResult' + this.chartId, this.resultChartConfig(this.dates, this.series) as any)
    }

    resultChartConfig (dates, series) {
        return {
            chart: {
                height: 350,
            },
            title:  {text: ''},
            xAxis: {
                categories: dates,
                type: 'datetime',
                dateTimeLabelFormats: {
                    day: "%a %e/%m"
                },
                title: {
                    text: null
                },
                crosshairs: {
                    color: 'black',
                    dashStyle: 'solid'
                },     
                startOnTick: true,
                endOnTick: true,
            },
            yAxis: {
                title: {
                    text: ''
                },
                min: 0,
                // max: 5
            },
            
            series: [
                ...series.data,
            ],
            tooltip: {
                enabled: true,
                // shared: true,
                // split: false,
                useHTML: true,
                // crosshairs: true,
                hideDelay: 1000,
                format: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{y}%</b>'
            },
        };
    }
}